import { Badge } from "../../components/Badge";
import {
  Link,
  useNavigate,
  useLocation,
} from "react-router-dom";
import { organizationStore } from "../../store/organization";
import { createApolloClient } from "../../providers/ApolloClientFactory";
import { RFID } from "../../types/rfid";
import { RFID_LIST_QUERY } from "./queries";
import React, { useEffect, useRef, useState } from "react";
import { eventStore } from "../../store/event";
import { usdFormat } from "../../utils";
import { usePermissions } from "../auth/api";
import {
  ColDef,
  GridApi,
  SizeColumnsToContentStrategy,
  ICellRendererParams,
} from "ag-grid-community";
import { Breadcrumbs } from "../../components/Breadcrumbs";
import { Input } from "../../components/inputs/Input";
import { PrimaryButton, SecondaryButton } from "../../components/Button";
import { AgGridReact } from "ag-grid-react";
import moment from "moment/moment";
import { userStore } from "../../store/user";
import {RFIDAssetsRow} from "../tickets/components/type";
import {downloadBrandedQR} from "../tickets/components/brandedQr";
import toast from "react-hot-toast";
import PromoCodeSendModal from "../../components/PromoCodeSendModal";
import {TICKET_SEND_EMAIL_SMS} from "../tickets/ticket-search/mutations";
import Loader from "../../components/Loader";
import UploadUIDsModal from "./UploadUIDsModal";

const client = createApolloClient();
const { getState } = organizationStore;
const { getState: getEventStore } = eventStore;
const { getState: getUserStore } = userStore;

const ButtonCellRenderer = (props: any) => {
  const { data } = props as { data: RFIDAssetsRow };
  const { id, uid } = data || {};
  const tokensBalance = data?.tokens_balance;
  let tokenStrings: string[];
  if (tokensBalance && Object.keys(tokensBalance).length > 0) {
    tokenStrings = Object.values<any>(tokensBalance).map(
        (token) => `${token.redeemable_token_name} - ${token.balance}`
    );
  }
  const handleDownloadClick = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    try {
      const accessType =
          (data as any)?.access_type || (data?.is_qr ? "QR Code" : "Asset");

      await downloadBrandedQR({
        uid: String(uid ?? ""),
        itemName: accessType,
        bottomText: `UID: ${uid}`,
        bottomText2: data.reg_id ? `Print ID: ${data?.reg_id}` : '',
        bottomText3: tokenStrings ? `Token Balance: ${tokenStrings}` : '',
        logoBase64: "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",
        qrSize: 500,
        logoSize: 100,
        fontSize: 24,
        fileName: `${String(accessType).replace(/\s+/g, "-")}-${uid}`,
      });

      toast.success("QR downloaded");
    } catch (error) {
      toast.error("Failed to download QR");
    }
  };

  return (
      <>
        <button
            onClick={handleDownloadClick}
            className="ml-2 rounded-md border border-gray-300 bg-gray-400 py-1 px-2 text-sm font-medium text-white shadow-sm hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2"
            title="Download QR"
        >
          Download QR
        </button>
      </>
  );
};

const buildSearch = (search: string) => [
  {
    uid: {
      _ilike: `%${search}%`,
    },
  },
  {
    last_four_phone_numbers: {
      _ilike: `%${search}%`,
    },
  },
  {
    reg_id: {
      _ilike: `%${search}%`,
    },
  },
  {
    notes: {
      _ilike: `%${search}%`,
    },
  },
];

type CellRenderer = (params: {
  value:
    | string
    | number
    | boolean
    | React.ReactElement<any, string | React.JSXElementConstructor<any>>
    | React.ReactFragment
    | React.ReactPortal
    | null
    | undefined;
  data: RFID;
}) => JSX.Element | null;
const createCellRenderer = (
  permission: boolean,
  linkFunc: (params: { data: RFID }) => string
): CellRenderer => {
  return (params) => {
    if (params.value === undefined) {
      return null;
    }

    return (
      <>
        {permission ? (
          <Link to={linkFunc(params)}>
            <Badge>{params.value}</Badge>
          </Link>
        ) : (
          <Badge>{params.value}</Badge>
        )}
      </>
    );
  };
};

export const RFIDAssetList = () => {
  const { editCreatePermission, ListPermission, moduleWisePermission } =
    usePermissions("cashless_assets");
  const { editCreatePermission: attendeesProcessorEditPermission } =
    usePermissions("attendees");
  const navigate = useNavigate();
  const location = useLocation();
  const gridRef = useRef<GridApi>();
  const [rowData, setRowData] = useState<RFID[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);
  const user = getUserStore().user;
  const isAdmin = user?.role?.name === "admin";

  useEffect(() => {
    let isMounted = true;

    const fetchRfidAssets = async () => {
      setIsLoading(true);
      try {
        const search = new URLSearchParams(location.search).get("search");
        const rawOrganizationId = getState().organizationId;
        const organizationId = parseInt(rawOrganizationId !== null ? rawOrganizationId.toString() : '', 10);
        const eventId = getEventStore().eventId;
        const user = getUserStore().user;

        let where: any = { _or: search ? buildSearch(search) : undefined };
        if (organizationId && organizationId !== 0) {
          where = {
            ...where,
            event: {
              organization_id: {
                _eq: organizationId,
              },
            },
          };
        }

        if (eventId) {
          where = {
            ...where,
            event_id: {
              _eq: eventId,
            },
          };
        } else if (user?.events) {
          where = {
            ...where,
            event_id: {
              _in: user?.events,
            },
          };
        }

        const { data } = await client.query({
          query: RFID_LIST_QUERY,
          variables: {
            where,
          },
        });

        if (isMounted) {
          setRowData(data.rfid_assets);
        }
      } catch (error) {
        console.error("Error fetching RFID assets:", error);
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    };

    fetchRfidAssets();
    return () => {
      isMounted = false;
    };
  }, [location.search]);
  const generateColDefs = (): ColDef<RFID>[] => [
    {
      headerName: "Unique ID",
      valueGetter: (p) => p.data?.uid,
      cellRenderer: createCellRenderer(
        editCreatePermission,
        (p) => `/rfid-assets/${p.data.id}/edit`
      ),
      filter: "agTextColumnFilter",
      pinned: "left",
    },
    {
      headerName: "Download as QR",
      cellRenderer: ButtonCellRenderer,
      minWidth: 75,
    },
    {
      headerName: "Print ID",
      valueGetter: (p) => p.data?.reg_id,
      filter: "agTextColumnFilter",
    },
    {
      headerName: "Asset Type",
      valueGetter: (p) => p.data?.is_qr,
      valueFormatter: (p) => {
        return p.data?.is_qr ? "QR" : "RFID";
      },
      filter: "agTextColumnFilter",
      filterValueGetter: (p) => (p.data?.is_qr ? "QR" : "RFID"),
    },
    {
      headerName: "Access Type",
      valueGetter: (p) => p.data?.access_type,
      filter: "agTextColumnFilter",
    },
    {
      headerName: "Attendee Linked",
      valueGetter: (p) => p.data?.is_active,
      valueFormatter: (p) => {
        return p.data?.is_active ? "Yes" : "No";
      },
      filter: "agTextColumnFilter",
      filterValueGetter: (p) => (p.data?.is_active ? "Yes" : "No"),
    },
    {
      headerName: "PIN",
      valueGetter: (p) => p.data?.last_four_phone_numbers,
      valueFormatter: (p) => {
        const phoneNumber = p.value;
        if (phoneNumber && phoneNumber.length >= 2) {
          const hiddenDigits = phoneNumber.slice(0, -2).replace(/\d/g, "*");
          const visibleDigits = phoneNumber.slice(-2);
          return hiddenDigits + visibleDigits;
        } else {
          return phoneNumber;
        }
      },
      filter: "agTextColumnFilter",
      filterValueGetter: (p) => {
        const phoneNumber = p.data?.last_four_phone_numbers;
        if (phoneNumber && phoneNumber.length >= 2) {
          const hiddenDigits = phoneNumber.slice(0, -2).replace(/\d/g, "*");
          const visibleDigits = phoneNumber.slice(-2);
          return hiddenDigits + visibleDigits;
        } else {
          return phoneNumber ?? "";
        }
      },
    },
    {
      headerName: "Promo Balance",
      valueGetter: (params) => {
        return params.data?.promo_balance;
      },
      valueFormatter: (params) => usdFormat.format((params.value ?? 0) / 100),
      filter: "agTextColumnFilter",
      filterValueGetter: (p) => usdFormat.format((p.data?.promo_balance ?? 0) / 100),
    },
    {
      headerName: "Cash Balance",
      valueGetter: (params) => {
        return params.data?.cash_balance;
      },
      valueFormatter: (params) => usdFormat.format((params.value ?? 0) / 100),
      filter: "agTextColumnFilter",
      filterValueGetter: (p) => usdFormat.format((p.data?.cash_balance ?? 0) / 100),
    },
    {
      headerName: "Token Balance",
      valueGetter: (params) => {
        const tokensBalance = params?.data?.tokens_balance;
        console.log("tokensBalance:", tokensBalance); // Log the tokensBalance object
        if (tokensBalance && Object.keys(tokensBalance).length > 0) {
          const tokenStrings = Object.values<any>(tokensBalance).map(
            (token) => `${token.redeemable_token_name} - ${token.balance}`
          );
          return tokenStrings.join(", ");
        }
        return null;
      },
      cellRenderer: (params: ICellRendererParams) => {
        const tokensBalance = params.value;

        if (tokensBalance) {
          return <div>{tokensBalance}</div>;
        }
        return null;
      },
      filter: "agTextColumnFilter",
      filterValueGetter: (p) => {
        const tokensBalance = p.data?.tokens_balance;
        if (tokensBalance && Object.keys(tokensBalance).length > 0) {
          const tokenStrings = Object.values<any>(tokensBalance).map(
            (token) => `${token.redeemable_token_name} - ${token.balance}`
          );
          return tokenStrings.join(", ");
        }
        return "";
      },
    },
    {
      headerName: "Attendee",
      valueGetter: (p) => {
        const firstName = p.data?.attendee?.first_name;
        const lastName = p.data?.attendee?.last_name;
        if (firstName === undefined || lastName === undefined) {
          return undefined;
        }
        return `${firstName} ${lastName}`.trim();
      },
      cellRenderer: createCellRenderer(
        editCreatePermission,
        (p) => `/attendees/${p.data.attendee_id}/edit`
      ),
      filter: "agTextColumnFilter",
      filterValueGetter: (p) => {
        const firstName = p.data?.attendee?.first_name;
        const lastName = p.data?.attendee?.last_name;
        if (firstName === undefined || lastName === undefined) {
          return "";
        }
        return `${firstName} ${lastName}`.trim();
      },
    },
    {
      headerName: "Notes",
      valueGetter: (p) => p.data?.notes,
      filter: "agTextColumnFilter",
    },
    {
      headerName: "Updated By",
      valueGetter: (p) => p.data?.user?.username,
    },
    {
      headerName: "Created Date",
      valueGetter: (p) => p.data?.created_at,
      valueFormatter: (p) => {
        const date = p.value ? moment(p.value) : null;
        return date ? date.format("MM/DD/YYYY h:mm:ss a") : "";
      },
      filter: "agTextColumnFilter",
      filterValueGetter: (p) =>
        p.data?.created_at ? moment(p.data.created_at).format("MM/DD/YYYY h:mm:ss a") : "",
    },
    {
      headerName: "Updated Date",
      valueGetter: (p) => p.data?.updated_at,
      valueFormatter: (p) => {
        const date = p.value ? moment(p.value) : null;
        return date ? date.format("MM/DD/YYYY h:mm:ss a") : "";
      },
      filter: "agTextColumnFilter",
      filterValueGetter: (p) =>
        p.data?.updated_at ? moment(p.data.updated_at).format("MM/DD/YYYY h:mm:ss a") : "",
    },
  ];
  const colDefs: ColDef<RFID>[] = generateColDefs();
  const rowHeight = 50;
  const autoSizeStrategy: SizeColumnsToContentStrategy = {
    type: "fitCellContents",
  };
  const handleExportCSV = () => {
    if (gridRef.current) {
      const timestamp = new Date().toISOString().replace(/[-:]/g, "");
      const params = {
        fileName: `CashlessAssets_${timestamp}.csv`,
        columnSeparator: ",",
      };
      gridRef.current.exportDataAsCsv(params);
    }
  };
  const gridOptions = {
    enableCellTextSelection: true,
  };
  return (
    <div style={{ height: "75vh" }}>
      <div
        className={"ag-theme-quartz"}
        style={{ width: "100%", height: "100%" }}
      >
        <div className=" grid gap-2 grid-cols-6">
          <Breadcrumbs />
          <div className="col-span-2 col-start-5 mt-2">
            <Input
              name="search"
              placeholder={`Search Cashless Assets`}
              onChange={(s) => {
                navigate(
                  s && typeof s === "string" && s.length > 0
                    ? `/rfid-assets/list?search=${s}`
                    : `/rfid-assets/list`
                );
              }}
            />
          </div>
          <div className="py-2 col-span-2 col-start-7 flex">
            <SecondaryButton onClick={handleExportCSV}>
              Export to CSV
            </SecondaryButton>
            {isAdmin && (
              <SecondaryButton onClick={() => setIsUploadModalOpen(true)}>
                Upload
              </SecondaryButton>
            )}
            {editCreatePermission && (
              <PrimaryButton onClick={() => navigate(`/rfid-assets/create`)}>
                Create
              </PrimaryButton>
            )}
          </div>
        </div>
        {isLoading ? (
          <Loader />
        ) : (
          <AgGridReact
            rowData={rowData}
            columnDefs={colDefs}
            rowHeight={rowHeight}
            autoSizeStrategy={autoSizeStrategy}
            pagination={true}
            gridOptions={gridOptions}
            paginationPageSize={100}
            onGridReady={(params) => (gridRef.current = params.api)}
          />
        )}
      </div>
      <UploadUIDsModal
        isOpen={isUploadModalOpen}
        onClose={() => setIsUploadModalOpen(false)}
      />
    </div>
  );
};
